// extracted by mini-css-extract-plugin
export default {"groupBadgeContainer":"GroupBadge_groupBadgeContainer__rn2UL","groupName":"GroupBadge_groupName__TivSW"};